import { Button, Flex, Image, Text } from "@chakra-ui/react"

import checkIcon from "#/assets/check.svg"
import { selectDepositActionType, useDappSelector } from "#/redux-state"

import BoostModalHeader from "./BoostModalHeader"

type BoostModalCompletedProps = { onClose: () => void }

export default function BoostModalCompleted({
  onClose,
}: BoostModalCompletedProps) {
  const lockType = useDappSelector(selectDepositActionType)

  return (
    <>
      <BoostModalHeader />
      <Flex m="59px 0 37px" alignItems="center" gap={4}>
        <Image src={checkIcon} />
        <Text variant="numbersL" color="green.highlight">
          {lockType === "extend" ? "Boost extended" : "Boost resumed!"}
        </Text>
      </Flex>
      <Button
        variant="secondary"
        size="large"
        borderWidth={2}
        onClick={onClose}
      >
        close
      </Button>
    </>
  )
}
